var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AxDialog',{on:{"after-leave":_vm.cancel},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('AxManageUsersLeave',{attrs:{"workspace":_vm.workspace},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }